export const TipoFirmaElectronica = {
    AUTOMATIZADA: "AUTOMATIZADA", CON_APROBACION: "CON_APROBACION"
};